<template>
  <div class="row">
    <!-- Header -->
    <div class="col-12 mb-4">
      <div class="d-flex align-items-center justify-content-between flex-wrap">
        <div class="d-flex align-items-center">
          <button @click="back" class="btn btn-outline-secondary btn-icon-text py-2 px-3 mr-3">
            <i class="mdi mdi-arrow-left mr-1"></i> {{ $t('common.back') }}
          </button>
          <div>
            <h2 class="text-white font-weight-bold mb-1">{{ $t('redeem.createTitle') }}</h2>
            <p class="text-muted small mb-0">{{ $t('redeem.createSub') }}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Form Card -->
    <div class="col-12 grid-margin">
      <div class="card border border-secondary">
        <div class="card-body">
          <!-- Quick Reward Presets -->
          <div class="rounded mb-4 p-3 d-flex align-items-center justify-content-between flex-wrap gap-2" style="background: rgba(30, 41, 59, 0.4); border: 1px solid #27272a;">
            <div class="d-flex align-items-center mb-2 mb-md-0">
              <i class="mdi mdi-lightning-bolt text-warning font-weight-bold mr-2" style="font-size: 1.25rem;"></i>
              <div>
                <div class="text-white font-weight-bold small">{{ $currentLocale === 'id' ? 'Template Hadiah Cepat' : 'Quick Reward Presets' }}</div>
                <div class="text-muted small">{{ $currentLocale === 'id' ? 'Pilih katalog hadiah populer untuk mengisi form secara otomatis' : 'Select a popular reward item to auto-fill the form' }}</div>
              </div>
            </div>
            <div class="d-flex flex-wrap gap-2">
              <button type="button" @click="applyPreset('coffee')" class="btn btn-xs btn-outline-warning mr-1 mb-1">
                <i class="mdi mdi-coffee mr-1"></i> {{ $currentLocale === 'id' ? 'Traktir Kopi (50 Gold)' : 'Coffee Treat (50 Gold)' }}
              </button>
              <button type="button" @click="applyPreset('ewallet')" class="btn btn-xs btn-outline-info mr-1 mb-1">
                <i class="mdi mdi-wallet mr-1"></i> {{ $currentLocale === 'id' ? 'E-Wallet 50rb (100 Gold)' : 'E-Wallet $5 / 50k (100 Gold)' }}
              </button>
              <button type="button" @click="applyPreset('lunch')" class="btn btn-xs btn-outline-success mr-1 mb-1">
                <i class="mdi mdi-food-fork-drink mr-1"></i> {{ $currentLocale === 'id' ? 'Makan Siang Tim (200 Gold)' : 'Team Lunch (200 Gold)' }}
              </button>
              <button type="button" @click="applyPreset('leave')" class="btn btn-xs btn-outline-primary mr-1 mb-1">
                <i class="mdi mdi-beach mr-1"></i> {{ $currentLocale === 'id' ? 'Cuti Fleksibel (300 Gold)' : 'Flexible Leave Pass (300 Gold)' }}
              </button>
              <button type="button" @click="applyPreset('merch')" class="btn btn-xs btn-outline-danger mb-1">
                <i class="mdi mdi-tshirt-crew mr-1"></i> {{ $currentLocale === 'id' ? 'Hoodie Eksklusif (500 Gold)' : 'Exclusive Hoodie (500 Gold)' }}
              </button>
            </div>
          </div>

          <form class="forms-sample" method="post" @submit.prevent="submitForm">
            <div class="form-group row">
              <div class="col-md-6 mb-3">
                <label for="nameInput" class="text-muted small text-uppercase font-weight-bold">{{ $t('redeem.itemName') }}</label>
                <input
                  id="nameInput"
                  type="text"
                  class="form-control"
                  v-model="ruleStore.name"
                  :placeholder="$currentLocale === 'id' ? 'Contoh: Voucher Belanja Tokopedia Rp 100.000' : 'e.g. Shopping Voucher / Gift Card $10'"
                  required
                />
              </div>
              <div class="col-md-6 mb-3">
                <label for="goldInput" class="text-muted small text-uppercase font-weight-bold">{{ $t('redeem.costGold') }}</label>
                <div class="input-group">
                  <input
                    id="goldInput"
                    type="number"
                    class="form-control"
                    v-model="ruleStore.gold"
                    min="1"
                    placeholder="100"
                    required
                  />
                  <div class="input-group-append">
                    <span class="input-group-text bg-dark border-secondary text-warning font-weight-bold">
                      <i class="mdi mdi-circle-multiple mr-1"></i> Gold
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div class="d-flex justify-content-end gap-2">
              <button type="button" @click="back" class="btn btn-outline-secondary px-4 py-2 mr-2" :disabled="loading">
                {{ $t('common.back') }}
              </button>
              <button type="submit" class="btn btn-primary px-4 py-2 font-weight-bold" :disabled="loading">
                <span class="spinner-border spinner-border-sm mr-1" v-if="loading" role="status"></span>
                <i class="mdi mdi-check-all mr-1" v-else></i>
                {{ $t('common.submit') }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { storeRedeem } from "../../services/redeemService";
import Swal from 'sweetalert2';

export default {
  data: () => ({
    ruleStore: {
      name: '',
      gold: 100,
    },
    loading: false,
  }),
  methods: {
    back() {
      this.$router.go(-1);
    },
    applyPreset(type) {
      const isId = this.$currentLocale === 'id';
      const presets = {
        coffee: {
          name: isId ? 'Voucher Traktir Kopi Susu / Minuman Favorit (Rp 25.000)' : 'Favorite Coffee / Beverage Voucher ($3)',
          gold: 50,
        },
        ewallet: {
          name: isId ? 'Voucher Saldo E-Wallet / Tokopedia Rp 50.000' : 'E-Wallet / Marketplace Gift Card ($5)',
          gold: 100,
        },
        lunch: {
          name: isId ? 'Traktir Makan Siang Bareng Tim / GrabFood Rp 100.000' : 'Team Lunch Treat / Food Delivery Voucher ($10)',
          gold: 200,
        },
        leave: {
          name: isId ? 'Tiket 1 Hari Cuti Fleksibel / Late Pass' : '1-Day Flexible Leave / Late Pass Ticket',
          gold: 300,
        },
        merch: {
          name: isId ? 'Hoodie / Jaket Eksklusif GamiTeam' : 'Special GamiTeam Exclusive Hoodie / Jacket',
          gold: 500,
        },
      };
      const p = presets[type];
      if (p) {
        this.ruleStore.name = p.name;
        this.ruleStore.gold = p.gold;
      }
    },
    async submitForm() {
      this.loading = true;
      try {
        await storeRedeem(this.ruleStore);
        Swal.fire({
          icon: 'success',
          title: this.$t('common.success'),
          text: this.$t('redeem.savedSuccess'),
          confirmButtonColor: '#3b82f6',
        });
        this.$router.push('/redeem');
      } catch (error) {
        console.error(error);
        const errMsg = error.response?.data?.message || (this.$currentLocale === 'id' ? 'Gagal menambahkan item hadiah' : 'Failed to add reward item');
        Swal.fire({
          icon: 'error',
          title: this.$t('common.error'),
          text: errMsg,
        });
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>
